import React, { Component } from 'react'
import { ButtonContainer, MainButton, Box, Wrapper } from './styled'

class AnimatedState extends Component {
  constructor(props) {
    super(props)
    this.state = { moveDirection: 'none', moving: false }
  }

  timeLapse = () => {
    this.setState({ moving: true })
    setTimeout(() => {
      this.setState({ moving: false })
    }, 1050)
    setTimeout(() => {
      this.setState({ moveDirection: 'none' })
    }, 1000)
  }

  moveBox = (type) => (ev) => {
    ev.preventDefault()
    if (type === 'left' && !this.state.moving) {
      this.timeLapse()
      this.setState({ moveDirection: 'left' })
    } else if (type === 'right' && !this.state.moving) {
      this.timeLapse()
      this.setState({ moveDirection: 'right' })
    }
  }

  render() {
    return (
      <Wrapper>
        <Box moveDirection={this.state.moveDirection} />
        <ButtonContainer>
          <MainButton onMouseDown={this.moveBox('left')}>
            Move Box Left
          </MainButton>
          <MainButton onMouseDown={this.moveBox('right')}>
            Move Box Right
          </MainButton>
        </ButtonContainer>
      </Wrapper>
    )
  }
}

export default AnimatedState
